import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { NativeComp } from './NativeComp';
import { WebComp } from './WebComp';

export const LoginWithGoogle = () => {
  React.useEffect(() => {}, []);
  const isWeb = Platform.OS === 'web';

  return (
    <View style={styles.container}>{isWeb ? <WebComp /> : <NativeComp />}</View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
